export function hexToUint8Array(hexString: string): Uint8Array {
  return new Uint8Array(
    hexString.match(/.{1,2}/g)?.map((byte) => parseInt(byte, 16)) ?? []
  )
}

export function uint8ArrayToString(data: Uint8Array): string {
  return new TextDecoder().decode(data)
}
